import { render, staticRenderFns } from "./AdministrationOrderModal.vue?vue&type=template&id=0713aafa&scoped=true&"
import script from "./AdministrationOrderModal.vue?vue&type=script&lang=js&"
export * from "./AdministrationOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0713aafa",
  null
  
)

export default component.exports